import { createFileRoute } from '@tanstack/react-router';
import { BlackoutDatesPage } from '@/pages/admin-self-booking/BlackoutDatesPage';

export const Route = createFileRoute('/_authenticated/_app/bookings/blackout-dates')({
	component: BlackoutDatesPage,
});
